import type { HTMLAttributes, ReactNode } from 'react';
import { useTheme } from '../../theme';

export interface StudentDashboardShellProps
  extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

/** Container principal: largura máxima, padding e coluna do dashboard do aluno. */
export function StudentDashboardShell({
  children,
  style,
  ...rest
}: StudentDashboardShellProps) {
  const theme = useTheme();
  const L = theme.layout.studentDashboard;

  return (
    <div
      style={{
        width: '100%',
        minWidth: 0,
        height: '100%',
        minHeight: 0,
        maxWidth: L.contentMaxWidth,
        margin: L.shellHorizontalMargin,
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing.lg,
        padding: `${theme.spacing.lg} ${theme.spacing.xl}`,
        ...style,
      }}
      {...rest}
    >
      {children}
    </div>
  );
}
